import React, { FC } from 'react';
import { SortableTable } from '../../molecules';
import { Action, Label, TableRow } from '../../atoms';
import { ParticipantResponseDto } from '../../../store/landscapeAPI/participant/dto/response/participant-response.dto';

interface LandscapeAboutParticipantsOrganismProps {
  participants: ParticipantResponseDto[];
  handleEdit: (id: string) => void;
  handleDelete: (id: string) => void;
}

const LandscapeAboutParticipantsOrganism: FC<
  LandscapeAboutParticipantsOrganismProps
> = ({ participants, handleEdit, handleDelete }) => {
  return (
    <SortableTable
      data={participants}
      columns={[
        { label: 'Participant Name', key: 'name' },
        { label: 'Url', key: 'url' },
        { label: 'Organisation', key: 'organisationType' },
      ]}
      renderRow={(row) => (
        <TableRow key={row.id}>
          <Label content={row.name} />
          <Label content={row.url ?? ''} />
          <Label content={row.organisationType} />
          <Action type="edit" onClick={() => handleEdit(row.id)} size="sm" />
          <Action
            type="delete"
            onClick={() => handleDelete(row.id)}
            size="sm"
          />
        </TableRow>
      )}
    />
  );
};

export default LandscapeAboutParticipantsOrganism;
